




































import mixins from '@/utils/mixins';
import Validatable from '@/mixins/validatable';
import BindsAttrs from '@/mixins/binds-attrs';
import Messages from './Messages.vue';
import { deepEqual, humanReadableFileSize } from '@/utils/helpers';

// Declare validation to align with vuetify v-form validation
const baseMixins = mixins(BindsAttrs, Validatable);
interface Options extends InstanceType<typeof baseMixins> {
  /* eslint-disable-next-line camelcase */
  $_modelEvent: string;
}

export default baseMixins
  .extend<Options>({
    functional: false
  })
  .extend({
    components: { Messages },
    name: 'ButtonFileInput',

    props: {
      label: { type: String, default: 'Choose File' },
      truncateLimit: { type: Number, default: 40 },
      clearable: Boolean,
      small: Boolean,
      large: Boolean
    },
    watch: {
      value(value: any) {
        if (!deepEqual([value], (this.$refs.input as HTMLInputElement).files)) {
          // When the input value is changed programatically, clear the
          // internal input's value so that the `onChange` handler
          // can be triggered again if the user re-selects the exact
          // same file(s). Ideally, `input.files` should be
          // manipulated directly but that property is readonly.
          (this.$refs.input as HTMLInputElement).value = '';
        }
      }
    },
    computed: {
      text(): string {
        if (!this.internalValue) return '';
        const { name = '', size = 0 } = this.internalValue as File;
        const truncatedText = this.displayText(name);
        return `${truncatedText} (${humanReadableFileSize(size, true)})`;
      }
    },

    methods: {
      displayText(str: string) {
        // if box is small then we want to make this size smaller
        if (str.length < this.truncateLimit) return str;
        const charsKeepOneSide = Math.floor((this.truncateLimit - 1) / 2);
        return `${str.slice(0, charsKeepOneSide)}…${str.slice(
          str.length - charsKeepOneSide
        )}`;
      },

      onChange(e: DragEvent) {
        const reader = new FileReader();
        const files =
          (e.target as HTMLInputElement)?.files || e.dataTransfer?.files || [];

        if (files.length) {
          reader.readAsDataURL(files[0]);
          this.$nextTick(() => {
            this.internalValue = files[0];
          });
          this.$emit('change', files[0]);
        }
      },

      // allow clearing the value from external activator
      clearableCallback() {
        if (this.$refs.input) {
          (this.$refs.input as HTMLInputElement).focus();
        }
        this.$nextTick(() => (this.internalValue = null));
        this.resetValidation();
      }
    }
  });
